export default function HeroSection() {
  return (
    <section className="tw-relative tw-w-full tw-h-[520px] md:tw-h-[620px] lg:tw-h-[720px] tw-overflow-hidden tw-bg-black">
      <img
        src="/eume/eume-ad-hero.png"
        alt="EUME luggage"
        className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover tw-object-right"
      />

      {/* left-to-right shade keeps the copy readable */}
      <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-black/[0.88] tw-via-black/60 tw-to-black/10" />

      <div className="tw-relative tw-h-full tw-max-w-[1120px] tw-mx-auto tw-px-6 xl:tw-px-0 tw-flex tw-items-center">
        <div className="tw-flex tw-flex-col tw-gap-6">
          <h1 className="tw-max-w-[640px] tw-text-[44px] md:tw-text-[56px] lg:tw-text-[68px] tw-leading-[1.09] tw-font-semibold tw-tracking-[-0.02em] tw-text-white">
            EUME Accidental Care Plan
          </h1>

          <p className="tw-max-w-[560px] tw-text-base md:tw-text-[19px] tw-leading-[30px] tw-text-white/85">
            Protection against sudden accidental damage to your EUME luggage
            and bags — drops, impacts, tears and airline baggage handling,
            during normal personal use.
          </p>
        </div>
      </div>
    </section>
  );
}
